import { internalChatMessages } from 'messages';
import { ConversationParticipantDto, MessageDto } from 'types';

export const calculateHeightMessageSystem = (
  message: MessageDto,
  props?: {
    isFirstOfSender?: boolean;
    isGroup?: boolean;
    isMe?: boolean;
    sender?: ConversationParticipantDto;
  }
): number => {
  if (!message) return 0;

  const clone = document.createElement('div');
  clone.className = 'relative min-w-[70px] max-w-[700px] whitespace-pre-wrap break-words px-3 py-2 text-center text-sm';
  clone.innerHTML = `${props?.isMe ? internalChatMessages.you : `${props?.sender?.name}${props?.sender?.extensionId ? ` (${props?.sender?.extensionId})` : ''}`}} ${message.content}`;
  document.body.appendChild(clone);
  const height = clone.offsetHeight;
  document.body.removeChild(clone);
  return height;
};
